import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import { formatDate, FORMAT_DATE_BACK, isEmpty, postSubmit, scrollToComponent, stringToDate } from "@ui-seeker/utils"

import { WEBBACK_V2_API, DATE_PERIODS } from "@constants"
import { CatalogueDetailsPriceEvolutionFilters } from "../../@signals"


export default function useCatalogueDetailsPriceEvolutionData() {
	const { showToast } = useAppToast()

	const dataEvolution = useSignal({})
	const dataEvolutionKeys = useSignal({})
	const charColors = useSignal({})
	const productTitle = useSignal("")
	const retailer = useSignal("")
	const isLoadingDataEvolution = useSignal(false)
	const currency = useSignal("")
	const evolutionDatePeriod = useSignal([])

    useEffect(() => {
		if (!isEmpty(CatalogueDetailsPriceEvolutionFilters.value)) batch(() => {
			isLoadingDataEvolution.value = true
            dataEvolution.value = {}
			showToast.promise(postSubmit(`${WEBBACK_V2_API}/catalogue/details/evolution`, CatalogueDetailsPriceEvolutionFilters.value).then(res => batch(() => {
                dataEvolution.value = res.chartData
				dataEvolutionKeys.value = res.chartKeys
				charColors.value = res.chartColors
				productTitle.value = res.productTitle
				currency.value = res.currency
				retailer.value = res.retailer
				evolutionDatePeriod.value = [stringToDate(CatalogueDetailsPriceEvolutionFilters.value.startDate), stringToDate(CatalogueDetailsPriceEvolutionFilters.value.endDate)]
                isLoadingDataEvolution.value = false
			})).catch(() => showToast.error()
            ).finally(() => scrollToComponent('evolution-price-chart')))
		}) 

		if (isEmpty(CatalogueDetailsPriceEvolutionFilters.value)) batch( () => {
			dataEvolution.value = {}
			dataEvolutionKeys.value = {}
			charColors.value = {}
			productTitle.value = ""
			currency.value = ""
			retailer.value = ""
			evolutionDatePeriod.value = []
		})

	}, [JSON.stringify(CatalogueDetailsPriceEvolutionFilters.value)])


    const resetEvolutionData = () => batch(() => {
		dataEvolution.value = {}
		dataEvolutionKeys.value = {}
		charColors.value = {}
		productTitle.value = ""
		retailer.value = ""
		currency.value = ""
		CatalogueDetailsPriceEvolutionFilters.value = {}
		evolutionDatePeriod.value = []
	})

	const handleChangeEvolutionPeriod = (e) => batch(() => {
		evolutionDatePeriod.value = e
		CatalogueDetailsPriceEvolutionFilters.value = {
			...CatalogueDetailsPriceEvolutionFilters.value,
			startDate: formatDate(e[0], { format: FORMAT_DATE_BACK  }),
			endDate: formatDate(e[1], { format: FORMAT_DATE_BACK  })
		}
	})

	return {
		dataEvolution: dataEvolution.value,
		isLoadingDataEvolution: isLoadingDataEvolution.value,
		dataEvolutionKeys: dataEvolutionKeys.value,
		currency: currency.value,
		productTitle: productTitle.value,
		evolutionDatePeriod: evolutionDatePeriod.value,
		chartColors: charColors.value,
		retailer: retailer.value,

        resetEvolutionData,
		handleChangeEvolutionPeriod
	}
}